import React from 'react'
import SystemSettingsList from '../../settings/system-settings-list'
import { Accordion } from 'react-bootstrap'
import JobsDashboard from '../../jobs/dashboard'
import useCurrentUser from '../../../hooks/use-current-user'
import LocationsDashboard from '../../locations/dashboard'

const SystemScreen = () => {
    const { isAdmin } = useCurrentUser()
    if (!isAdmin) {
        return null
    }
    return (
        <div>
            <LocationsDashboard/>
            <JobsDashboard />
            <div style={{ padding: '20px'}}>
                <h1>Settings</h1>
                <Accordion>
                    <SystemSettingsList />
                </Accordion>
            </div>
        </div>
    )
}

export default SystemScreen